import { ReactNode } from "react";
import Controls from "./Controls";
import Progress, { ProgressIcon } from "./Progress";
import RoomHeader from "./RoomHeader";
import { useTranslation } from "./Localization";
import { useTourMode } from "./TourMode";

type Props = { instruction?: string; taskKey?: string; step: number; backTo: string; nextTo: string; progressIcon?: ProgressIcon; children: ReactNode };

export default function EstateActivityLayout({ instruction = "", taskKey, step, backTo, nextTo, progressIcon = "center", children }: Props) {
  const { room } = useTranslation();
  const { interactive } = useTourMode();
  return <main className="screen activity estate-activity">
    <RoomHeader roomId="estate" />
    <p className="instruction">{(taskKey && room("estate")?.tasks[taskKey]) || instruction}</p>
    <div className="estate-task-content">{children}</div>
    <Progress step={step} total={3} icon={progressIcon} showDots={interactive} />
    <Controls backTo={backTo} nextTo={nextTo} />
  </main>;
}
